import intersection from 'lodash/intersection';
import { IBuildingTypes, IBuildingTypesConfig } from '../types/filters/building_types';
import { ISearchConfig } from '../types/search';
import { AbstractFlatSearchConfig, SearchConfig } from '../containers/SearchBlockContainer/search_config';
import { BuildingTypes, BuildingTypesWithAbstractFlat } from '../components/search_filters/building_types';

export const experimentSections = ['index', 'sale'];

const abstractFlatTypeFromBuildingType = (buildingTypes: string[]): string[] => {
  if (intersection(['new_flat', 'secondary_flat'], buildingTypes).length) {
    return ['flat'];
  }

  return buildingTypes;
};

export const getFiltersConfiguration = (
  actualBuildingType: IBuildingTypes,
  section: string,
): {
  buildingType: IBuildingTypes;
  actualBuildingType: IBuildingTypes;
  buildingTypes: IBuildingTypesConfig;
  searchConfig: ISearchConfig;
} => {
  let searchConfig = SearchConfig;
  let buildingType = actualBuildingType;
  let buildingTypes = BuildingTypes;

  if (experimentSections.includes(section)) {
    // подмена new_flat и secondary_flat на flat для первого дропдауна
    // при наличии отдельного дропдауна выбора типа квартиры
    buildingType = {
      buildingType: abstractFlatTypeFromBuildingType(actualBuildingType.buildingType),
      isDirty: false,
    };

    // вынесение типов "квартира во вторичке" "квартира в новостройке"
    // для первого дропдауна при наличии отдельного дропдауна выбора типа квартиры
    buildingTypes = BuildingTypesWithAbstractFlat;

    // показ дропдауна выбора типа квартиры
    // для типа сделки "купить" и трех типов квартир (общая / в новостройке / во вторичке)
    searchConfig = AbstractFlatSearchConfig;
  }

  return {
    actualBuildingType,
    buildingType,
    buildingTypes,
    searchConfig,
  };
};
